import { useFormContext } from 'react-hook-form';
import { LwFormInput } from 'redesign';
import { getRequiredMessage } from './shared';
import { ContactNameFormContext, Props } from './contact-name.types';

export const ContactNameInput = (props: Props) => {
  const { control } = useFormContext<ContactNameFormContext>();
  const formName = 'contactName';
  const label = 'Contactpersoon';
  const requiredMessage = getRequiredMessage(label);

  return (
    <LwFormInput
      name={formName}
      control={control}
      label={label}
      disabled={props.disabled}
      rules={props.required ? { required: requiredMessage } : undefined}
    />
  );
};
